<template>
  <div
    class="title-wrap"
    :class="fadeClasses"
  >
    <h2
      ref="title"
      class="title"
    >
      <slot></slot>
    </h2>
  </div>
</template>

<script>
import { TweenMax } from 'gsap'
import { fadeMixin } from '@/mixins'

export default {
  name: 'Title',
  mixins: [fadeMixin],
  mounted () {
    const scene = this.$scrollmagic.scene({
      triggerHook: 1,
      triggerElement: this.$refs.title,
      duration: '200%'
    })

    this.$scrollmagic.addScene(
      scene.setTween(TweenMax.to(this.$refs.title, 1, {
        y: '-70%'
      }))
    )
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: $fs-heading;
  line-height: $lh-heading;
  font-weight: $fw-bold;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 1em;
  position: relative;
  z-index: 2;
}
</style>
